import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IExperimentVm } from '@yakoffice/publisher-types';
import { formatISODateStringAsLocal } from '../common/Utils';
import { YoPublisherTable, YoTableClassNames } from '../../components/yo-publisher-table/YoPublisherTable';


interface PropsType {
    className?: string,
    experiments: IExperimentVm[],
    title: string,
}


export const ExperimentVmTable: FC<PropsType> = observer((props) => {

    return (
        <div className="mdcDataTableWrapper">
            <div className="mdcDataTableContainer">
                <YoPublisherTable
                    className={YoTableClassNames.MinWidth100}>
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Comment</th>
                        <th>Last Updated</th>
                        <th>Last Author</th>
                    </tr>
                    </thead>
                    <tbody>
                    {props.experiments.map(experiment => (
                        <tr key={experiment.id}>
                            <td>{experiment.id}</td>
                            <td>{experiment.name}</td>
                            <td className="max-width">{experiment.description}</td>
                            <td className="max-width">{experiment.comment}</td>
                            <td>{formatISODateStringAsLocal(experiment.updatedAt)}</td>
                            <td>{experiment.lastAuthor}</td>
                        </tr>
                    ))
                    }
                    </tbody>
                </YoPublisherTable>
            </div>
        </div>
    );
});
